import Icon from '@/components/ui/icon';

function Loader() {
  return (
    <div
      className="flex h-full w-full items-center justify-center p-4"
      role="status"
      aria-live="polite"
    >
      <Icon name="Loader2" className="h-6 w-6 animate-spin" aria-hidden="true" />
      <span className="sr-only">Laddar…</span>
    </div>
  );
}

export { Loader };
